import { useMutation, useQueryClient } from '@tanstack/react-query';

type Props = {
  /** Query key prefix of the list to refetch afterwards. */
  listKey: string;
  remove: () => Promise<unknown>;
  label?: string;
  confirmText?: string;
};

/** Row "delete" button: confirm → request → refetch list. */
export const DeleteButton = ({
  listKey,
  remove,
  label = 'Удалить',
  confirmText = 'Удалить запись?',
}: Props) => {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: remove,
    onSuccess: () => qc.invalidateQueries({ queryKey: [listKey] }),
    onError: () => window.alert('Не удалось удалить запись'),
  });

  return (
    <button
      type="button"
      className="btn btn-danger btn-sm"
      disabled={mutation.isPending}
      onClick={() => window.confirm(confirmText) && mutation.mutate()}
    >
      {label}
    </button>
  );
};
